module.exports = __webpack_public_path__ + "img/38.0303dd6e.jpg";